var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEpisodes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.538,
    className: "episodes_svg__outline",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.84866 6.8572h13.41867c.42539 0 .76924.336.76924.74998v8.67804",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.0355V4.74998C22 4.336 21.65538 4 21.23076 4H7.92594",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.07406 16.14257v-5.67811c0-.41474-.34462-.74998-.76924-.74998H2.76924c-.42539 0-.76924.33524-.76924.74998v7.78556C2 18.664 2.34385 19 2.76924 19h12.53558c.42462 0 .76924-.336.76924-.74998v-2.10745",
    fill: "currentColor"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/episodes.svg";
export { SvgEpisodes as ReactComponent };